<script setup lang="ts">
import type {GenreChildData} from "~/types/GenreData";
import {darkenColor} from "~/utils/format";

const props = defineProps<{
  genre: GenreChildData
}>();

const darkColor = computed(() => darkenColor(props.genre.color, 80));
</script>

<template>
  <UBadge
      variant="outline"
      class="font-mono text-xs flex-none"
      :style="{ borderColor: darkColor, backgroundColor: genre.color + '!important', color: darkColor + '!important' }"
      size="xs"
  >
    {{ genre.name }}
  </UBadge>
</template>
